import { render, staticRenderFns } from "./ModalAskRateValue.vue?vue&type=template&id=72b831fa&scoped=true&"
import script from "./ModalAskRateValue.vue?vue&type=script&lang=js&"
export * from "./ModalAskRateValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b831fa",
  null
  
)

export default component.exports